import React from "react";
import { cx } from "utils/join-classnames";
import { Modal, FormElement } from "ui/components";
import { useFormValidation } from "ui/hooks/use-form-validation";
import styles from "./ContactModal.module.scss";

interface Props {
    onSend(message: string): void;
    onClose(): void;
}

const ContactModal: React.FC<Props> = ({ onSend, onClose }: Props) => {
    const [isSending, setIsSending] = React.useState<boolean>(false);

    const theForm = useFormValidation({
        message: {
            valid: false,
            touched: false,
            title: "Message",
            value: "",
            errorMsg: "",
            rules: {
                required: true,
                minLength: 2,
            },
        },
    });
    const handleSend = () => {
        setIsSending(true);
        onSend(theForm.formState.message.value?.toString() || "");
    };
    const modalContent = (
        <div className={styles.container}>
            <div className={cx(styles.formelement, styles.infotext)}>
                Let us know what we can help you with, we will try to get back
                to you as soon as possible.
            </div>
            <FormElement
                type="textarea"
                theme="dark"
                title={theForm.formState.message.title || ""}
                id="requestLivestreamMessage"
                onChange={(value) => {
                    theForm.inputChangeHandler("message", value);
                }}
                defaultText="Your message"
                fieldState={theForm.formState.message}
            />
        </div>
    );
    return (
        <Modal
            content={modalContent}
            lineColor="amber"
            theme="dark"
            onSave={handleSend}
            onClose={onClose}
            saveButtonDisabled={!theForm.formValid || isSending}
            saveButtonText="Send"
            title="Contact us"
            icon="email"
            takeContentSize
        />
    );
};

export default ContactModal;
